import {FC, useMemo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {Badge, JsonViewer, ShowMore} from 'ui-kit';
import {isJsonString} from '@kcast-fe/core';

interface IProps {
  role: string;
  type: string;
  text: string;
}

export const TextSlot: FC<IProps> = ({role, text, type}) => {
  const isTool = useMemo(() => {
    return role === 'tool';
  }, [role]);

  const isToolJson = useMemo(() => {
    return isTool && isJsonString(text);
  }, [isTool, text]);

  return (
    <Flex pl={'16px'} flexDirection={'column'} gap={'4px'}>
      <Box>
        <Badge variant={isTool ? 'success' : 'neutral'}>Block · {type}</Badge>
      </Box>
      <Box px={'2px'} whiteSpace={'pre-wrap'} wordBreak={'break-word'}>
        {isToolJson ? <JsonViewer args={JSON.parse(text)} /> : <ShowMore text={text} />}
      </Box>
    </Flex>
  );
};
